<template>
  <div id="bond">
    <p class="header">{{ header }}</p>
    <p
      class="info"
      v-if="info"
    >{{ info }}</p>
    <div class="bond-level">
      <div
        class="hearts"
        v-if="lootState !== 'max'"
      >
        <img
          v-for="(filled, i) in hearts"
          :key="i"
          :src=" filled ? heartFilled : heart"
        >
      </div>
      <div
        class="progress-bar"
        v-if="lootState === 'grind'"
      >
        <progress-bar
          size="large"
          :val="progressTowardsNextHeart"
          bar-color="#f1c25a"
        ></progress-bar>
      </div>
    </div>
    <div class="loot">
      <p
        class="loot-alert"
        v-if="infoSecondary"
      >{{ infoSecondary }}</p>
      <img
        v-if="lootState === 'new' && lastUnlockedLoot"
        class="loot-icon"
        :src="lastUnlockedLoot.icon"
      >
      <img
        class="loot-background-icon"
        :src="backgroundIcon"
      >
      <p
        v-if="lootState === 'new' && lastUnlockedLoot"
        :style="{ fontWeight: 'bold' }"
      >{{ lastUnlockedLoot.name.toUpperCase() }}</p>
      <p v-if="lootState === 'dayMax'">More loot will be here on your next visit.</p>
    </div>
    <button
      class="button primary"
      @click="customize()"
      v-if="lootState === 'new'"
    >CUSTOMIZE PATHFINDER</button>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import times from "lodash.times";
  import * as heart from "@/assets/icons/heart.svg";
  import * as heartFilled from "@/assets/icons/heart-filled.svg";
  import * as closedLootBox from "@/assets/icons/loot-box-gold.svg";
  import * as openLootBox from "@/assets/icons/loot-box-open.svg";
  import * as lootCheck from "@/assets/icons/loot-check.svg";
  import * as fullBond from "@/assets/icons/full-bond.svg";
  import ProgressBar from "vue-simple-progress";

  export default {
    components: {
      ProgressBar
    },
    data() {
      return {
        closedLootBox,
        openLootBox,
        heart,
        heartFilled
      };
    },
    methods: {
      ...mapActions(["despawnPathfinder"]),
      customize() {
        this.$router.push({ name: "customize" });
      }
    },
    computed: {
      ...mapGetters(["newLoot", "dayMaxLoot", "maxLoot"]),
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        lastUnlockedLoot: state => state.pathfinders.lastUnlockedLoot,
        HEARTS_TO_LOOT: state => state.pathfinders.HEARTS_TO_LOOT,
        PACKAGES_TO_HEART: state => state.pathfinders.PACKAGES_TO_HEART
      }),
      header() {
        if (this.lootState === "max") return "WELL DONE!";
        if (this.lootState === "dayMax") return "FRIENDSHIP LEVEL";
        return "CONNECTION WITH YOUR PATHFINDER";
      },
      info() {
        if (this.lootState === "max")
          return "You have an AMAZING friendship with your pathfinder";
        if (this.lootState === "grind")
          return "The stronger your connection, the more loot you'll earn";
        return null;
      },
      infoSecondary() {
        if (this.lootState === "new") return "You've unlocked a new loot box!";
        if (this.lootState === "dayMax") return "You've done a great job today!";
        return null;
      },
      backgroundIcon() {
        if (this.lootState === "max") return fullBond;
        if (this.lootState === "dayMax") return lootCheck;
        if (this.lootState === "new") return openLootBox;
        else return closedLootBox;
      },
      lootState() {
        if (this.maxLoot) return "max";
        if (this.dayMaxLoot) return "dayMax";
        if (this.newLoot) return "new";
        else return "grind";
      },
      filled() {
        return Math.floor(
          (this.pathfinder.bond / this.PACKAGES_TO_HEART) % this.HEARTS_TO_LOOT
        );
      },
      progressTowardsNextHeart() {
        return (
          (this.pathfinder.bond % this.PACKAGES_TO_HEART) *
          (100 / this.PACKAGES_TO_HEART)
        );
      },
      hearts() {
        if (["new", "dayMax"].includes(this.lootState)) {
          return times(this.HEARTS_TO_LOOT, n => true);
        } else {
          const unfilled = this.HEARTS_TO_LOOT - this.filled;
          return times(this.filled, n => true).concat(
            times(unfilled, n => false)
          );
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #bond {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      text-align: center;
    }

    .header,
    .info {
      margin-bottom: 0.5em;
    }

    p.header {
      font-weight: bold;
      font-size: 1.5em;
    }

    .bond-level,
    .loot {
      width: 75%;

      @media only screen and (min-width: 600px) {
        width: 65%;
      }

      margin: auto;
    }

    .bond-level {
      display: flex;
      flex-direction: column;
      align-items: center;

      .hearts {
        margin-bottom: 1em;
        margin-top: 1em;

        img {
          margin-left: 0.5em;
          margin-right: 0.5em;
        }
      }

      .progress-bar {
        margin-bottom: 1.5em;
      }
    }

    .loot {
      position: relative;
      margin-bottom: 1.5em;
      margin-top: 0.5em;
      display: flex;
      flex-direction: column;
      align-items: center;

      .loot-background-icon,
      .loot-alert {
        margin-bottom: 1em;
      }

      .loot-background-icon {
        width: 80%;
      }

      .loot-icon {
        position: absolute;
        transform: translateY(75%);
      }
    }

    @keyframes bounce {
      0% {
        transform: translateY(0px) scaleY(1);
      }
      100% {
        transform: translateY(-5px) scaleY(1.02);
      }
    }
  }
</style>
